import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { forEach } from '@angular/router/src/utils/collection';
import { Constants, SessionObject, ProjectUtils } from 'app/pages/shared';
import { PushLiveAndRollBackService } from 'app/pages/insight/processing/push-live-and-roll-back/push-live-and-roll-back.service';

@Component({
  selector: 'app-push-live-table',
  templateUrl: './push-live-table.component.html',
  styleUrls: ['./push-live-table.component.css'],
  providers: [PushLiveAndRollBackService]
})
export class PushLiveTableComponent implements OnInit {
  @Input() tableData: Array<any>;
  @Output() processComplete: EventEmitter<any> = new EventEmitter();
  private keyElement: any;
  private showTable = false;
  private data: Array<any>;
  private tableHeader = [];
  model: any = {};

  sessionObject: SessionObject = SessionObject.getSessionObject();
  
  constructor(private pushLiveAndRollBackService: PushLiveAndRollBackService) { }


  ngOnInit() {
    this.initializeData();
  }
  private initializeData() {
    if (this.tableData == null) {
      this.showTable = false;
    } else {
      this.data = this.tableData;
      this.showTable = true;
      this.tableHeading()
    }
  }

  tableHeading() {
    this.tableHeader = Object.keys(this.data[0]);
  }

  downloadAccountLive(item: any) {
    const url = `${Constants.IN_INST_STATS_ACCOUNT_LIST}?token=${this.sessionObject.activeCurrentUser.token}&accountstatus=LIVE&month=${item["Month_Year"]}`;
    ProjectUtils.downloadGET(url);

  }
  downloadAccountQA(item) {
    const url = `${Constants.IN_INST_STATS_ACCOUNT_LIST}?token=${this.sessionObject.activeCurrentUser.token}&accountstatus=QA&month=${item["Month_Year"]}`;
    ProjectUtils.downloadGET(url);
  }
  message : any;
  pushlive(item) {
    const month= item["Month_Year"];
    this.pushLiveAndRollBackService.pushLiveselectedmonth(month).subscribe(data => {
      alert("Reports successfully pushed Live for Month : "+month);
    }, err => {
      alert("Unable to pushed Live Reports for Month : "+month);
    });
    
  }
}



// WEBPACK FOOTER //
// ./src/app/components/push-live-table/push-live-table.component.ts